<!-- <div class="row"> -->
    <!-- <div class="col-12" style="margin-top: 100px;">

    </div> -->
<!-- </div> -->

<section class="">
    <div class="mobile-filter-toggle d-md-none" (click)="toggleMobileFilter()">
  <i class="fa fa-sliders-h"></i> <!-- or use any icon you like -->
</div>
<div class="mobile-fixed-filter-pills-wrapper d-md-none">
    <div class="pills-scroll-container fixed-filter-pills">
        <div class="filter-pill-item mobile-location-input">
 <tag-input [ngModel]='tagValues' [identifyBy]="'value'"
  [displayBy]="'label'" [onlyFromAutocomplete]="true" [ngModelOptions]="{standalone: true}"
  (onAdd)="onAdded($event)" (onRemove)="onDelete($event)" secondaryPlaceholder="Location"
  placeholder="+ Add Location">
  <tag-input-dropdown [showDropdownIfEmpty]="true" [autocompleteObservable]="requestAutocompleteItems"
   [identifyBy]="'value'" [displayBy]="'label'">
  </tag-input-dropdown>
 </tag-input>
  </div>

        <div class="filter-pill-item dropdown-pill" (click)="toggleRentPriceLimitDropdown()"
            [class.selected]="searchWhere.selling_type">
            {{ (searchWhere.selling_type || 'Rent/Sale') | capitalize }}
            <i class="fa fa-chevron-down icon-arrow"></i>
            <div class="mobile-pill-dropdown" *ngIf="isPriceLimitRentDropdownOpen" (click)="$event.stopPropagation()">
                <div *ngFor="let option of propertyTypes" (click)="selectPriceLimitOption(option)"
                    class="dropdown-option">
                    {{ option }}
                </div>
            </div>
        </div>

        <div class="filter-pill-item dropdown-pill" (click)="toggleDropdown()"
            [class.selected]="searchWhere.property_type_value">
            {{ (searchWhere.property_type_value || 'Property Type') | capitalize }}
            <i class="fa fa-chevron-down icon-arrow"></i>
            <div class="mobile-pill-dropdown" *ngIf="isDropdownOpen" (click)="$event.stopPropagation()">
                <div *ngFor="let option of dropdownValues3" (click)="selectOption(option)" class="dropdown-option">
                    {{ option.property_type }}
                </div>
            </div>
        </div>

        <div class="filter-pill-item" [class.selected]="searchWhereActual.min_price || searchWhereActual.max_price"
            (click)="togglePriceFilter($event)">
            {{ getPriceLable() }}
        </div>
        <div class="filter-pill-item"
            [class.selected]="searchWhereActual.bedroom_value || searchWhereActual.bathroom_value" (click)="onView()">
            {{(searchWhereActual.bedroom_value || searchWhereActual.bathroom_value) ?
            searchWhereActual.bedroom_value + (searchWhereActual.bathroom_value ? ',' : '') +
            searchWhereActual.bathroom_value : "Beds & Baths"}}
        </div>

        <div class="filter-pill-item"
            [class.selected]="(searchWhereActual.amenities.length > 0 || searchWhereActual.furnishing_type != '' || searchWhereActual.min_size != '' || searchWhereActual.max_size != '')"
            (click)="onFilter()">
            More Filters
        </div>

        <div class="filter-pill-item find-pill" (click)="onFind()">
            Find
        </div>

    </div>
</div>
    <div class="fixed-search" *ngIf="!isMyProperty" [class.open]="isMobileFilterOpen">
        <div class="row mt-4 mb-1" *ngIf="isBrowser">
            <div class="col-12">
                <tag-input class="inline-div location-input" [ngModel]='tagValues' [identifyBy]="'value'"
                    [displayBy]="'label'" [onlyFromAutocomplete]="true" [ngModelOptions]="{standalone: true}"
                    (onAdd)="onAdded($event)" (onRemove)="onDelete($event)" secondaryPlaceholder="Location"
                    placeholder="+ Add">
                    <tag-input-dropdown [showDropdownIfEmpty]="true" [autocompleteObservable]="requestAutocompleteItems"
                        [identifyBy]="'value'" [displayBy]="'label'">
                    </tag-input-dropdown>
                </tag-input>
                <div class="inline-div mb-1 cursor">
                    <div class="form-select choose" (click)="toggleRentPriceLimitDropdown()"
                    style="display: inline-block; width: auto; background-color: white; color: black;"
                        [ngClass]="searchWhere.selling_type ? 'selected-select-box' : ''">
                        <div class="select-wrap">
                            <div class="custom-dropdown pos-relative rent-dropdown">
                                <div class="selected-option">
                                    {{ (searchWhere.selling_type || 'Rent') | capitalize }}
                                </div>
                                <div class="options" *ngIf="isPriceLimitRentDropdownOpen">
                                    <div *ngFor="let option of propertyTypes" (click)="selectPriceLimitOption(option)">
                                        {{ option }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="inline-div mb-1 cursor">
                    <div class="form-select choose" (click)="toggleDropdown()"
                        [ngClass]="searchWhere.property_type_value ? 'selected-select-box' : ''">
                        <div class="select-wrap">
                            <div class="icon">
                                <!-- <span class="fa fa-chevron-down"></span> -->
                            </div>
                            <div class="custom-dropdown pos-relative rent-dropdown cursor">
                                <div class="selected-option white-space-nowrap">
                                    {{ (searchWhere.property_type_value || 'Property type') | capitalize }}
                                </div>
                                <div class="options" *ngIf="isDropdownOpen">
                                    <div *ngFor="let option of dropdownValues3" (click)="selectOption(option)">
                                        {{ option.property_type }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
             <div class="inline-div mb-1 price-filter-wrapper">
  <!-- Price filter button -->
  <div
    class="filter-main-button"
    [ngClass]="{'selected': searchWhereActual.min_price || searchWhereActual.max_price}"
    (click)="togglePriceFilter($event)">
    {{ getPriceLable() }}
  </div>

  <!-- Price filter dropdown -->
  <div class="price-filter-box" *ngIf="isPriceFilterOpen" (click)="$event.stopPropagation()">
    <div class="filter-dropdowns-row">
      
      <!-- Min Dropdown -->
      <div class="custom-dropdown min-dropdown" (click)="toggleMinDropdown($event)">
        <div class="selected-value">
          {{ searchWhereActual.min_price || 'Min' }}
        </div>
        <div class="options-menu min-options" *ngIf="isMinDropdownOpen" (click)="$event.stopPropagation()">
          <div
            class="option-item reset-option"
            (click)="selectMinPrice('Min')"
            [ngClass]="{'selected': !searchWhereActual.min_price}">
            Min
          </div>
          <div
            *ngFor="let option of priceOptions"
            class="option-item"
            [ngClass]="{'selected': searchWhereActual.min_price === option}"
            (click)="selectMinPrice(option)">
            {{ option }} AED
          </div>
        </div>
      </div>

      <span class="separator">-</span>

      <!-- Max Dropdown -->
      <div class="custom-dropdown max-dropdown" (click)="toggleMaxDropdown($event)">
        <div class="selected-value">
          {{ searchWhereActual.max_price || 'Max' }}
        </div>
        <div class="options-menu max-options" *ngIf="isMaxDropdownOpen" (click)="$event.stopPropagation()">
          <div
            class="option-item reset-option"
            (click)="selectMaxPrice('Max')"
            [ngClass]="{'selected': !searchWhereActual.max_price}">
            Max
          </div>
          <div
            *ngFor="let option of priceOptions"
            class="option-item"
            [ngClass]="{'selected': searchWhereActual.max_price === option}"
            (click)="selectMaxPrice(option)">
            {{ option }} AED
          </div>
        </div>
      </div>

    </div>

    <div class="clear-all-row">
      <div class="clear-all" (click)="clearAll()">Clear All</div>
    </div>
  </div>
</div>

                <div class="inline-div mb-1">
                    <button type="button" class="btn  price white-space-nowrap arrow-background" (click)="onView()"
                        [ngClass]="(searchWhereActual.bedroom_value || searchWhereActual.bathroom_value) ? 'selected-select-box' : ''">
                        <!-- {{(searchWhereActual.bedroom_value || searchWhereActual.bathroom_value) ? searchWhereActual.bedroom_value + (searchWhereActual.bedroom_value ? ',' : '') + searchWhereActual.bathroom_value : "Beds & Baths"}} -->
                        {{(searchWhereActual.bedroom_value || searchWhereActual.bathroom_value) ?
                        searchWhereActual.bedroom_value + (searchWhereActual.bathroom_value ? ',' : '') +
                        searchWhereActual.bathroom_value : "Beds & Baths"}}
                    </button>
                </div>

                <div class="inline-div mb-1 ">
                    <button type="button"
                        [ngClass]="(searchWhereActual.amenities.length > 0 || searchWhereActual.furnishing_type != '' || searchWhereActual.min_size != '' || searchWhereActual.max_size != '') ? 'selected-select-box' : ''"
                        class="btn  price white-space-nowrap  filter-button" (click)="onFilter()">
                        More Filters
                    </button>
                </div>
                <div class="inline-div mb-1 ">
                    <button type="submit" id="findbtn" class="btn btn-find" (click)="onFind()">Find</button>
                </div>
            </div>
        </div>
    </div>
    <div class="row" *ngIf="!isMyProperty">
        <div class="col-12 border-bottom-line">
            &nbsp;
        </div>
    </div>
    <div class="container-xl">
        <div class="row mt-2 mb-5">
            <div class="col-12">
                <!-- <ol class="breadcrumb">
                    <li class="breadcrumb-item"><a href="/home"><i class="flaticon-home icon"></i></a></li>
                    <li class="breadcrumb-item active">Properties for
                        {{searchWhereActual.selling_type == '1' ? 'sale' : 'rent'}} in {{searchWhereActual.city ||
                        'UAE'}}</li>
                </ol> -->
                <!-- <form [formGroup]="propertyForm"   *ngIf="shared.isUserLoggedIn">
                    <div class="row">
                      <div class="col-6">
                        <div class="mb-3">
                          <label for="propertyName" class="form-label">Property Name</label>
                          <input type="text" id="propertyName" class="form-control" formControlName="propertyName" />
                        </div>
                      </div>
                
                      <div class="col-6">
                        <div class="mb-3">
                          <label for="propertyStatus" class="form-label">Property Status</label>
                          <select id="propertyStatus" class="form-select" formControlName="propertyStatus">
                            <option value="" disabled>All</option>
                            <option value="0">Pending</option>
                            <option value="1">Approved</option>
                            <option value="2">Rejected</option>
                          </select>
                        </div>
                      </div>
                
                      <div class="col-6">
                        <div class="mb-3">
                          <label for="developerName" class="form-label">Developer Name</label>
                          <select id="developerName" class="form-select" formControlName="developerName">
                            <option value="" disabled selected>Select Developer</option> 
                            <option *ngFor="let developer of developerList" [value]="developer.developer_id">
                                {{ developer.developer_name }}
                              </option>
                          </select>
                        </div>
                      </div>
                      
                      
                      <div class="col-6">
                        <div class="mb-3">
                          <label for="location" class="form-label">Location</label>
                          <input type="text" id="location" class="form-control" formControlName="location" />
                        </div>
                      </div>
                
                      <div class="col-6">
                        <div class="mb-3">
                          <label for="emirate" class="form-label">Emirate</label>
                          <select id="emirate" class="form-select" formControlName="emirate">
                            <option value="">All</option>
                            <option *ngFor="let emirate of emirateOptions" [value]="emirate.id">{{ emirate.city }}</option>
                          </select>
                        </div>
                      </div>
                    </div>
                
                    <button type="submit" class="btn btn-theme mb-3"  (click)="onSubmitForm()">Submit</button>
                  </form> -->
                <div class="row">
                    <div class="col-9">
                        <h2 *ngIf="!isMyProperty">
                            Properties for {{searchWhereActual.selling_type == '1' ? 'sale' : 'rent'}} in
                            {{searchWhereActual.city || 'UAE'}}
                            <!-- {{searchWhereActual.landmark_id ? "- " + searchWhereActual.landmark : ""}}
                            {{currentPage > 1 ? ", Page " + currentPage : ""}} -->
                        </h2>
                       <div class="mobile-count-sort-row d-flex justify-content-between align-items-center d-md-none">
            <!-- <p *ngIf="!isMyProperty" class="view mb-0">{{totalCount}} properties</p> -->

            <button class="btn mobile-action-btn sort-btn" (click)="openSortModal()"> 
                <i class="fa fa-sort"></i> Sort 
            </button>
        </div>
        <div class="mobile-sort-options-menu d-md-none" *ngIf="isMobileSortOpen">
            <div class="sort-option-item" 
                 (click)="selectMobileSortOption('is_featured|DESC')"
                 [class.selected]="searchWhereActual.sort_order === 'is_featured|DESC'">
                Featured
            </div>
            <div class="sort-option-item" 
                 (click)="selectMobileSortOption('created_at|DESC')"
                 [class.selected]="searchWhereActual.sort_order === 'created_at|DESC'">
                Newest
            </div>
            <div class="sort-option-item" 
                 (click)="selectMobileSortOption('price|ASC')"
                 [class.selected]="searchWhereActual.sort_order === 'price|ASC'">
                Price (low)
            </div>
            <div class="sort-option-item" 
                 (click)="selectMobileSortOption('price|DESC')"
                 [class.selected]="searchWhereActual.sort_order === 'price|DESC'">
                Price (high)
            </div>
            <div class="sort-option-item" 
                 (click)="selectMobileSortOption('no_of_bedrooms|ASC')"
                 [class.selected]="searchWhereActual.sort_order === 'no_of_bedrooms|ASC'">
                Beds (least)
            </div>
            <div class="sort-option-item" 
                 (click)="selectMobileSortOption('no_of_bedrooms|DESC')"
                 [class.selected]="searchWhereActual.sort_order === 'no_of_bedrooms|DESC'">
                Beds (most)
            </div>
        </div>


                        <div class="btn-group" role="group" aria-label="Button Tabs"   *ngIf="shared.isUserLoggedIn">
                            <button class="btn btn-sm"  [ngClass]="{
                                'btn-secondary': selectedTab !== 'pending', 
                                'btn-pending active': selectedTab === 'pending'
                              }" (click)="selectTab('pending')" id="pending-btn" type="button" role="tab">
                                Pending
                            </button>

                            <button class="btn btn-sm ms-2" [ngClass]="{
                                'btn-secondary': selectedTab !== 'approved', 
                                'btn-approved active': selectedTab === 'approved'
                              }" (click)="selectTab('approved')" id="approved-btn" type="button" role="tab">
                                Approved
                            </button>

                            <button class="btn btn-sm ms-2" [ngClass]="{
                                'btn-secondary': selectedTab !== 'rejected', 
                                'btn-rejected active': selectedTab === 'rejected'
                              }" (click)="selectTab('rejected')" id="rejected-btn" type="button" role="tab">
                                Rejected
                            </button>
                        </div>

                    </div>
                  
                    <div class="col-3 d-none d-md-block">
                        <div class="container mb-2">
                            <div class="text-md-end">
                                <div class="row justify-content-md-end">
                                    <div class="text-md-end col-auto">
                                        <label for="sortSelect" class="form-label sortby">Sort By:</label>
                                    </div>
                                    <div class="col-auto">
                                        <select class="form-select select-box" id="sortSelect" (change)="onFind()"
                                            [(ngModel)]="searchWhereActual.sort_order">
                                            <option value="is_featured|DESC">Featured</option>
                                            <option value="created_at|DESC">Newest</option>
                                            <option value="price|ASC">Price (low)</option>
                                            <option value="price|DESC">Price (high)</option>
                                            <option value="no_of_bedrooms|ASC">Beds (least)</option>
                                            <option value="no_of_bedrooms|DESC">Beds (most)</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="mobile-landmark-pills-wrapper d-md-none"
                    *ngIf="(cityCountRecords.length > 0 || landmarkCountRecords.length > 0) && !searchWhereActual.landmark_id">
                    <div class="pills-scroll-container">
                
                        <ng-container *ngFor="let record of cityCountRecords">
                            <a class="filter-pill-item"
                                [routerLink]="'/properties/city/' + record['PropertyToMasterCityData.city_name']">
                                {{ record['PropertyToMasterCityData.city_name'] }} ({{ record.property_count }})
                            </a>
                        </ng-container>
                
                        <ng-container *ngFor="let record of landmarkCountRecords">
                            <a class="filter-pill-item" *ngIf="record['PropertyToMasterLandmarkData.landmark_name']"
                                [routerLink]="['/properties/city/', searchWhereActual.city]"
                                [queryParams]="{ landmark: record['PropertyToMasterLandmarkData.landmark_name'] }">
                                {{ record['PropertyToMasterLandmarkData.landmark_name'] }} ({{ record.property_count }})
                            </a>
                        </ng-container>
                
                    </div>
                </div>
                <div class="card mt-3 d-none d-md-block"
                    *ngIf="(cityCountRecords.length > 0 || landmarkCountRecords.length > 0) && !searchWhereActual.landmark_id">
                    <div class="card-body">
                        <div class="row mt-2">
                            <div *ngFor="let propertyType of cityCountRecords" class="col-4">
                                <a class="text"
                                    [routerLink]="'/properties/city/' + propertyType['PropertyToMasterCityData.city_name']">
                                    {{ propertyType['PropertyToMasterCityData.city_name'] }} <span class="view">({{
                                        propertyType.property_count }})</span>
                                </a>
                            </div>

                            <ng-container *ngFor="let propertyType of landmarkCountRecords">
                                <div class="col-4" *ngIf="propertyType['PropertyToMasterLandmarkData.landmark_name']">
                                    <a class="text" [routerLink]="['/properties/city/', searchWhereActual.city]"
                                        [queryParams]="{ landmark: propertyType['PropertyToMasterLandmarkData.landmark_name'] }">
                                        {{ propertyType['PropertyToMasterLandmarkData.landmark_name'] }} <span
                                            class="view">({{ propertyType.property_count }})</span>
                                    </a>
                                </div>
                            </ng-container>
                        </div>
                    </div>
                </div>

                <div class="row justify-content-center" *ngIf="isLoaded && propertyList.length == 0">
                    <div class="col-md-12">
                        <div class="alert alert-theme-blue text-center" role="alert">
                            <h4 class="alert-heading">We currently have no properties matching your search.</h4>
                            <p>Please try something different</p>
                        </div>
                    </div>
                </div>
            <div class="row mt-2">
                <ng-container *ngFor="let propertyData of propertyList">
                   
                        <app-common-property [propertyData]='propertyData' [isMyProperty]=isMyProperty></app-common-property>
                    
                </ng-container>
            </div>
            <div class="button-container">
                <button *ngIf="hasMoreProperties"  class="load-more-btn" (click)="loadMoreProperties()">
                    Load More Properties
                </button>
                </div>





                <!-- <div class="card mt-5">
                    <div class="row g-0">
                        <div class="col-md-4">
                            <img src="../../assets/images/work-1.jpg" alt="Card image" class="img-fluid">
                        </div>
                        <div class="col-md-8">
                            <div class="card-body">
                                <h5 class="view mb-2">
                                    Townhouse
                                </h5>
                                <h3>
                                    220,000 AED/year
                                </h3>
                                <h5 class="mb-5">
                                    Vacant Family Home | Large layout | Type 3E
                                </h5>

                                <h5 class="location view mt-5">
                                    <i class="ion-ios-pin"></i> Mira 5, Mira, Reem, Dubai
                                </h5>
                                <div class="row  property_list  mb-0">
                                    <h5 class="space">
                                        <span class="flaticon-bed icon"></span>3
                                    </h5>
                                    <h5 class="space">
                                        <span class="flaticon-bathtub icon"></span>2
                                    </h5>
                                    <h5 class="space">
                                        <span class="flaticon-blueprint icon"></span>1,878 sqft
                                    </h5>
                                </div>
                            </div>
                        </div>
                        <div class="button-row text-end">
                            <div class="row justify-content-end last">
                                <div class="col-auto">
                                    <button type="button" class="btn social " (click)="onRemark()">
                                        Contact developer
                                    </button>
                                </div>
                                <div class="col-auto">
                                    <button class="btn social"><i class="ion-ios-call img"></i>Call</button>
                                </div>
                                <div class="col-auto">
                                    <button class="btn social"><i class="ion-ios-mail img"></i>Email</button>
                                </div>
                                <div class="col-auto">
                                    <button class="btn social"><i class="ion-logo-whatsapp img"></i>WhatsApp</button>
                                </div>
                                <div class="col-auto">
                                    <button class="btn social"><i class="ion-ios-heart img"></i></button>
                                </div>
                                <div class="col-auto">
                                    <button class="btn social"><i class="ion-ios-menu img"></i></button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> -->

                <!-- <div class="text-center mt-3">
                    <button type="button" class="btn btn-primary" (click)="onRemark()">
                        Contact detail
                    </button>
                </div> -->

            </div>
        </div>

    </div>
</section>

<ng-container *ngIf="isRemarkModal">
    <div class="modal fade show" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
        style="display: block;">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header text-center">
                    <h5 class="modal-title dark" id="staticBackdropLabel">
                        Contact developer about this project
                    </h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal"
                        (click)="closeRemarkModal()"></button>
                </div>
                <div class="modal-body text">
                    <p>Fill out your contact details and a representative from <span class="dark">Emaar Properties
                        </span>will get back to you as soon as possible.</p>
                    <form>
                        <div class="mt-2">
                            <!-- Name Field -->
                            <div class="mb-3">
                                <label for="name" class="form-label">Name</label>
                                <input type="text" class="form-control" id="name" name="name" required>
                            </div>

                            <!-- Email Field -->
                            <div class="mb-3">
                                <label for="email" class="form-label">Email</label>
                                <input type="email" class="form-control" id="email" name="email" required>
                            </div>
                            <div class="mb-3">
                                <label for="phoneNumber" class="form-label">Phone Number</label>
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <select class="form-select" id="countryCode">
                                            <option value="+971"><img class="flag-img"
                                                    src="../../assets/images/united_arab_emirates.png" alt="UAE Flag">
                                                +971</option>
                                            <!-- Add more options for other country codes if needed -->
                                        </select>
                                    </div>
                                    <input type="tel" class="form-control" id="phoneNumber" required>
                                </div>
                            </div>
                            <!-- <div class="mb-3">
                                <label for="phoneNumber" class="form-label">Phone Number</label>
                                <div class="input-group">
                                    <div class="dropdown">
                                        <button class="btn btn-secondary dropdown-toggle" type="button" id="countryDropdown" data-bs-toggle="dropdown">
                                            <img class="flag-img" src="../../assets/images/india.png" alt="India Flag"> +91
                                        </button>
                                        <div class="dropdown-menu">
                                            <a class="dropdown-item" href="#" data-value="+91"><img class="flag-img" src="../../assets/images/india.png" alt="India Flag"> +91</a>
                                            <a class="dropdown-item" href="#" data-value="+971"><img class="flag-img" src="../../assets/images/united_arab_emirates.png" alt="UAE Flag"> +971</a>
                                            Add more options for other country codes if needed
                                        </div>
                                    </div>
                                    <input type="tel" class="form-control" id="phoneNumber" placeholder="Enter your phone number" required>
                                </div>
                            </div> -->

                        </div>
                    </form>
                </div>

                <div class="modal-footer">
                    <button type="button" class="btn contact" (click)="onSubmit()">Submit</button>
                </div>
            </div>
        </div>
    </div>
</ng-container>

<ng-container *ngIf="isViewRemarkModal">
    <div class="modal fade show" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
        style="display: block;">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header text-center">
                    <!-- <h5 class="modal-title" id="staticBackdropLabel">
                        confirmation 
                    </h5> -->
                    <button type="button" class="btn-close" data-bs-dismiss="modal"
                        (click)="closeViewRemarkModal()"></button>
                </div>

                <div class="modal-body">
                    <form>
                        <div class="row mb-4">
                            <div class="col-6" [class.open]="isElectricityConnectionDropdownOpen">
                                <label for="minAreaDropdown">Min. Price</label>
                                <div class="">
                                    <div class="form-field">
                                        <div class="select-wrap">
                                            <div class="icon"></div>
                                            <div class="custom-dropdown electricity-connection-dropdown">
                                                <div class="selected-option"
                                                    (click)="toggleElectricityConnectionDropdown()"
                                                    id="minAreaDropdown">
                                                    <input type="text" class="form-control" name="min_price"
                                                        [(ngModel)]="searchWhereActual.min_price" />
                                                    <!-- {{ electricityConnectionSelectedOption || 'Select an option' }} -->
                                                </div>
                                                <div class="options" *ngIf="isElectricityConnectionDropdownOpen">
                                                    <div *ngFor="let option of dropdownValues"
                                                        (click)="selectMinPriceOption(option)"
                                                        [ngClass]="searchWhereActual.min_price == option ? 'selected-option-dropdown' : ''">
                                                        {{ option }}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-6" [class.open]="isMaxAreaDropdownOpen">
                                <label for="maxAreaDropdown">Max. Price</label>
                                <div class="">
                                    <div class="form-field">
                                        <div class="select-wrap">
                                            <div class="icon"></div>
                                            <div class="custom-dropdown max-area-dropdown">
                                                <div class="selected-option" (click)="toggleMaxAreaDropdown()"
                                                    id="maxAreaDropdown">
                                                    <input type="text" class="form-control" name="max_price"
                                                        [(ngModel)]="searchWhereActual.max_price" />
                                                </div>
                                                <div class="options" *ngIf="isMaxAreaDropdownOpen">
                                                    <div *ngFor="let option of dropdownValues"
                                                        (click)="selectMaxPriceOption(option)"
                                                        [ngClass]="searchWhereActual.max_price == option ? 'selected-option-dropdown' : ''">
                                                        {{ option }}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </form>
                    <ng-container *ngIf="searchWhereActual.selling_type == '2'">
                        <p class="bold">Rental Period</p>
                        <div class="button-row">
                            <button class="button"
                                [ngClass]="searchWhereActual.rental_period == 'Yearly' ? 'selected-select-box' : ''"
                                (click)="searchWhereActual.rental_period = 'Yearly'">Yearly</button>
                            <button class="button"
                                [ngClass]="searchWhereActual.rental_period == 'Quarterly' ? 'selected-select-box' : ''"
                                (click)="searchWhereActual.rental_period = 'Quarterly'">Quarterly</button>
                            <button class="button"
                                [ngClass]="searchWhereActual.rental_period == 'Monthly' ? 'selected-select-box' : ''"
                                (click)="searchWhereActual.rental_period = 'Monthly'">Monthly</button>
                        </div>
                    </ng-container>
                </div>

                <div class="modal-footer">
                    <button type="button" class="btn submit selected-select-box"
                        (click)="closeViewRemarkModal()">Close</button>
                </div>
            </div>
        </div>
    </div>
</ng-container>

<ng-container *ngIf="isView">
    <div class="modal fade show" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
        style="display: block;">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header text-center">
                    <h5 class="modal-title" id="staticBackdropLabel">
                        Beds & Baths
                    </h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="closeViewModal()"></button>
                </div>

                <div class="modal-body">
                    <p class="bold">Bedrooms</p>
                    <div class="button-row mb-3">
                        <button class="count" [ngClass]="selectedBedroom['1'] ? 'selected-select-box' : ''"
                            (click)="selectBedroom('1')">1</button>
                        <button class="count" [ngClass]="selectedBedroom['2'] ? 'selected-select-box' : ''"
                            (click)="selectBedroom('2')">2</button>
                        <button class="count" [ngClass]="selectedBedroom['3'] ? 'selected-select-box' : ''"
                            (click)="selectBedroom('3')">3</button>
                        <button class="count" [ngClass]="selectedBedroom['4'] ? 'selected-select-box' : ''"
                            (click)="selectBedroom('4')">4</button>
                        <button class="count" [ngClass]="selectedBedroom['5'] ? 'selected-select-box' : ''"
                            (click)="selectBedroom('5')">5</button>
                        <button class="count" [ngClass]="selectedBedroom['6'] ? 'selected-select-box' : ''"
                            (click)="selectBedroom('6')">6</button>
                        <button class="count" [ngClass]="selectedBedroom['7'] ? 'selected-select-box' : ''"
                            (click)="selectBedroom('7')">7</button>
                        <button class="count" [ngClass]="selectedBedroom['7+'] ? 'selected-select-box' : ''"
                            (click)="selectBedroom('7+')">7+</button>
                    </div>

                    <p class="bold">Bathrooms</p>
                    <div class="button-row">
                        <button class="count" [ngClass]="selectedBathroom['1'] ? 'selected-select-box' : ''"
                            (click)="selectBathroom('1')">1</button>
                        <button class="count" [ngClass]="selectedBathroom['2'] ? 'selected-select-box' : ''"
                            (click)="selectBathroom('2')">2</button>
                        <button class="count" [ngClass]="selectedBathroom['3'] ? 'selected-select-box' : ''"
                            (click)="selectBathroom('3')">3</button>
                        <button class="count" [ngClass]="selectedBathroom['4'] ? 'selected-select-box' : ''"
                            (click)="selectBathroom('4')">4</button>
                        <button class="count" [ngClass]="selectedBathroom['5'] ? 'selected-select-box' : ''"
                            (click)="selectBathroom('5')">5</button>
                        <button class="count" [ngClass]="selectedBathroom['6'] ? 'selected-select-box' : ''"
                            (click)="selectBathroom('6')">6</button>
                        <button class="count" [ngClass]="selectedBathroom['7'] ? 'selected-select-box' : ''"
                            (click)="selectBathroom('7')">7</button>
                        <button class="count" [ngClass]="selectedBathroom['7+'] ? 'selected-select-box' : ''"
                            (click)="selectBathroom('7+')">7+</button>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" (click)="clearBedBathVal()">
                        Clear
                    </button>
                    <button type="button" class="btn submit selected-select-box" (click)="closeViewModal()">
                        Close
                    </button>
                </div>
            </div>
        </div>
    </div>
</ng-container>

<ng-container *ngIf="isFilter">
    <div class="modal fade show" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
        style="display: block;">
        <div class="modal-dialog ">
            <div class="modal-content">
                <div class="modal-header text-center">
                    <h5 class="modal-title" id="staticBackdropLabel">
                        More Filters
                    </h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal"
                        (click)="closeFilterModal()"></button>
                </div>

                <div class="modal-body">
                    <div class="row">
                        <p class="bold">Furnishing</p>
                        <div class="button-row mb-3">
                            <button (click)="searchWhereActual.furnishing_type = ''"
                                [ngClass]="searchWhereActual.furnishing_type == '' ? 'selected-select-box' : ''"
                                class="partly">All furnishings</button>
                            <button (click)="searchWhereActual.furnishing_type = 1"
                                [ngClass]="searchWhereActual.furnishing_type == 1  ? 'selected-select-box' : ''"
                                class="partly">Furnished</button>
                            <button (click)="searchWhereActual.furnishing_type = 2"
                                [ngClass]="searchWhereActual.furnishing_type == 2  ? 'selected-select-box' : ''"
                                class="partly">Unfurnished</button>
                            <button (click)="searchWhereActual.furnishing_type = 3"
                                [ngClass]="searchWhereActual.furnishing_type == 3  ? 'selected-select-box' : ''"
                                class="partly">Partly furnished</button>
                        </div>
                        <div class="bordered-element mt-2"></div>
                        <p class="bold">Property Size (Sqft)</p>
                        <form>
                            <div class="row mb-4">
                                <!-- <div class="col-6">
                                    <div class="form-floating">
                                        <select class="form-select" id="minPrice">
                                            <option value="" disabled selected></option>
                                            <option *ngFor="let value of dropdownValues" [value]="value">{{ value |
                                                number
                                                }} </option>
                                        </select>
                                        <label for="minPrice">Min. Area </label>
                                    </div>
                                </div> -->
                                <div class="col-6" [class.open]="isElectricityConnectionDropdownOpen">
                                    <!-- <label for="minAreaDropdown">Min. Area</label> -->
                                    <div class="form-control box_1">
                                        <div class="form-field">
                                            <div class="select-wrap">
                                                <div class="icon"></div>
                                                <div class="custom-dropdown electricity-connection-dropdown">
                                                    <div class="selected-option"
                                                        (click)="toggleElectricityConnectionDropdown()"
                                                        id="minAreaDropdown">
                                                        {{ searchWhereActual.min_size || 'Min. Area' }}
                                                    </div>
                                                    <div class="options" *ngIf="isElectricityConnectionDropdownOpen">
                                                        <div *ngFor="let option of dropdownValuesArea"
                                                            (click)="selectMinSize(option)"
                                                            [ngClass]="searchWhereActual.min_size == option ? 'selected-option-dropdown' : ''">
                                                            {{ option }}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-6" [class.open]="isMaxAreaDropdownOpen">
                                    <!-- <label for="maxAreaDropdown">Max. Area</label> -->
                                    <div class="form-control box_1">
                                        <div class="form-field">
                                            <div class="select-wrap">
                                                <div class="icon"></div>
                                                <div class="custom-dropdown max-area-dropdown">
                                                    <div class="selected-option" (click)="toggleMaxAreaDropdown()"
                                                        id="maxAreaDropdown">
                                                        {{ searchWhereActual.max_size || 'Max. Area' }}
                                                    </div>
                                                    <div class="options" *ngIf="isMaxAreaDropdownOpen">
                                                        <div *ngFor="let option of dropdownValuesArea2"
                                                            (click)="selectMaxArea(option)"
                                                            [ngClass]="searchWhereActual.max_size == option ? 'selected-option-dropdown' : ''">
                                                            {{ option }}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- <div class="col-6">
                                    <div class="form-floating">
                                        <select class="form-select" id="maxPrice">
                                            <option value="" disabled selected></option>
                                            <option *ngFor="let value of dropdownValues2" [value]="value">{{ value |
                                                number
                                                }} </option>
                                        </select>
                                        <label for="maxPrice">Max. Area</label>
                                    </div>
                                </div> -->
                            </div>
                        </form>
                        <div class="bordered-element mt-2"></div>
                        <p class="bold">Amenities</p>
                        <div class="scrolling-container">
                            <ul class="button-list mb-3">
                                <ng-container *ngFor="let af of amenitiesFilter">
                                    <li class="count" (click)="selectAmenitiesFilter(af)"
                                        [ngClass]="searchWhereActual.amenities.indexOf(af) >= 0 ? 'selected-select-box' : ''">
                                        {{af}}</li>
                                </ng-container>
                            </ul>
                        </div>


                        <!-- <div class="bordered-element mt-2"></div>
                        <p class="bold mt-3">Keywords</p>
                        <div class="col-md-12 mb-3">
                            <div class="form-group">
                                <input type="text" class="form-control" name="keywords" id="keywords"
                                    placeholder="Keywords: e.g. beach, chiller free">
                            </div>
                        </div> -->
                        <!-- <div class="bordered-element mt-2"></div>
                        <p class="bold">Virtual Viewings</p>
                        <div class="button-row mb-3">
                            <button class="part">All Virtual Viewings</button>
                            <button class="part">360 Tours</button>
                            <button class="part">Video Tours</button>
                            <button class="part">Live Viewings</button>
                        </div> -->
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" (click)="clearAllFilter()">Clear All</button>
                    <button type="button" (click)="onFind()" class="btn submit selected-select-box">Done</button>
                </div>
            </div>
        </div>
    </div>
</ng-container>

<div id="popoverPriceMainDiv">
    <div id="popoverPriceMainDiv1">
    </div>
    <div id="popoverPriceMainDiv2">
    </div>
    <div id="popoverPriceMainDiv3">
    </div>
</div>